import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';

import { useAnalytics } from '@Shared/useAnalytics';
import { selectTrade } from '@Header/ducks/selectors';
import CarValueCard from '../../../Shared/CarValueCard';
import MenuButton from '../../../Shared/MenuButton';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const DefaultTradeButton = styled(MenuButton)`
  color: ${props => props.theme.carvana.blue.dark};
  display: flex;
  flex: 1;
  font-size: 12px;
  justify-content: flex-start;
  padding: 15px 0;
  position: absolute;
  top: 0;
  left: 0;
  text-decoration: none;

  opacity: 1;
  ${props => props.animation};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 14px;
    letter-spacing: 0.1px;
    min-height: 50px;
    padding: 15px 19px;
    width: 100%;
  }
`;

const CarValueWrapper = styled.div`
  display: flex;
  flex: 1;
  padding: 20px 0 20px 0;
  position: absolute;
  top: 0;
  left: 0;

  opacity: 1;
  ${props => props.animation};

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    padding: 15px 20px;
  }
`;

const GetCarValueTypography = styled.div`
  color: ${props => props.theme.carvana.gray.dark};
  font-size: 13px;
  font-weight: 400;
  text-transform: none;
`;

const YourCarValueWrapper = styled.div`
  max-width: 233px;
`;

const YourCarValueTypography = styled.div`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 5px;
  text-transform: uppercase;

  @media (min-width: ${props => props.theme.breakpoints.values.sm}px) {
    font-size: 14px;
    white-space: nowrap;
  }
`;

const CarValueInfo = ({ hasFetchedData, trade }) => {
  const { trackEventAndGo } = useAnalytics();
  const animation = hasFetchedData
    ? null
    : css`
            animation: ${fadeIn} 250ms ease-out;
    `;
  const hasTrade = trade && trade.hasTrade;
  const hasManualAppraisal = trade && trade.isManual;
  if (hasTrade) {
    return (
      <CarValueWrapper animation={animation}>
        <YourCarValueWrapper>
          <YourCarValueTypography>
            Your Car&apos;s Offer Is...
          </YourCarValueTypography>
          <CarValueCard trade={trade} />
        </YourCarValueWrapper>
      </CarValueWrapper>
    );
  }

  return (
    <DefaultTradeButton onClick={e => trackEventAndGo(e, 'clicked trades link', {}, '/trades')} href="/trades" target="_self" animation={animation}>
      <div>
        {hasManualAppraisal ? 'Offer Pending' : "What's Your Car Worth?"}
        <GetCarValueTypography>
          {hasManualAppraisal ? 'See Details' : 'Get My Offer'}
        </GetCarValueTypography>
      </div>
    </DefaultTradeButton>
  );
};

CarValueInfo.defaultProps = {
  trade: null
};

CarValueInfo.propTypes = {
  hasFetchedData: PropTypes.bool.isRequired,
  trade: PropTypes.shape({})
};

const mapStateToProps = state => ({
  trade: selectTrade(state)
});

export default connect(mapStateToProps)(CarValueInfo);
